import { ButtonBase, Typography } from '@material-ui/core'
import CheckIcon from '@material-ui/icons/Check'
import React from 'react'
import { useLocation } from 'react-router-dom'

import { getTranslate } from '../../localization'
import { LocalizedLink } from '../../routes/localizedRoutes'
import { RoomTypeBrief } from '../../types/roomtype'
import useStyles from './styles/RoomtypesTable.styles'

interface UserRowProps {
  data: RoomTypeBrief
  hasAccessToViewRoomTypeTabs: boolean | undefined
  isRoleAdmin: boolean
}

const RoomtypeRow: React.FC<UserRowProps> = ({
  data,
  hasAccessToViewRoomTypeTabs,
  isRoleAdmin
}) => {
  const {
    name,
    displayRoomTypeCode,
    roomTypeCode,
    id,
    defaultOccupancy,
    maxOccupancy,
    roomCount,
    type,
    deleted,
    active
  } = data

  const classes = useStyles()
  const location = useLocation()

  const checkIcon = (input: boolean) => {
    if (input) {
      return <CheckIcon />
    }
  }

  return (
    <div
      className={[
        classes.tableRowRoot,
        isRoleAdmin ? classes.tableRowRootAdmin : ''
      ].join(' ')}>
      <ButtonBase
        className={[
          classes.tableRow,
          isRoleAdmin ? classes.tableRowAdmin : ''
        ].join(' ')}
        component={LocalizedLink}
        to={
          hasAccessToViewRoomTypeTabs
            ? `${location.pathname
                .replace('/list', '')
                .replace('/en', '')
                .replace('/fa', '')}/${id}/${roomTypeCode}/details`
            : ''
        }>
        <div className={classes.nameCell}>
          <Typography variant="h4">{name}</Typography>
        </div>
        <div>
          <Typography variant="body1">{displayRoomTypeCode}</Typography>
        </div>
        <div>
          <Typography variant="body1">{getTranslate(type)}</Typography>
        </div>
        <div>
          <Typography variant="body1">{defaultOccupancy}</Typography>
        </div>
        <div>
          <Typography variant="body1">{maxOccupancy}</Typography>
        </div>
        <div>
          <Typography variant="body1">{roomCount}</Typography>
        </div>
        {isRoleAdmin && (
          <>
            <div>{checkIcon(deleted)}</div>
            <div>{checkIcon(!active)}</div>
          </>
        )}
      </ButtonBase>
    </div>
  )
}

export default RoomtypeRow
